import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { isAdminNotConsultant, isConsultantOrHolding, hasRole, getIdUserFromSession } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { TASTING_PHOTOS } from "@/js/lists.ts";
import Error from "@/views/error/error.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultForm = {
  comment: "",
  contents: [{
    tastingPhotoRequiredId: null,
    nbBottles: 1
  }]
};
export default {
  name: "TastingPhotoUploadFormModal",
  components: {
    Error: Error,
    Confirm: Confirm,
    UploaderV2: UploaderV2,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    tastingPhotoRequiredId: Number || null
  },
  data: function data() {
    return {
      hasAccessToPage: true,
      dialog: false,
      userIdTarget: null,
      isCommentShown: false,
      form: _objectSpread({}, defaultForm),
      uploaderFiles: [],
      urlAddPhoto: "".concat(process.env.VUE_APP_API_URL, "/v1/tasting-photos/creation"),
      isSaving: false,
      availablePhotosRequired: {
        isPending: false,
        cancellationToken: null,
        items: []
      },
      availableUsers: {
        isPending: false,
        cancellationToken: null,
        items: []
      },
      formRules: formRules,
      filterIntegerKey: filterIntegerKey,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAnyFocused: function isAnyFocused() {
      return false;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isSaving;
    },
    canBeSubmitted: function canBeSubmitted() {
      var _this$uploaderFiles;
      return ((_this$uploaderFiles = this.uploaderFiles) === null || _this$uploaderFiles === void 0 ? void 0 : _this$uploaderFiles.length) > 0 && this.form.valid;
    },
    formWithouValidNormalized: function formWithouValidNormalized() {
      var _this$form = this.form,
        valid = _this$form.valid,
        withoutValid = _objectWithoutProperties(_this$form, _excluded);
      withoutValid.contents = withoutValid.contents.map(function (content) {
        content.nbBottles = +content.nbBottles;
        return content;
      });
      withoutValid.targetedUserId = +this.userIdTarget;
      return withoutValid;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isAdminNotConsultant(_this2.loggedUserData) && !hasRole(process.env.VUE_APP_ROLES_MANAGE_TASTING_PHOTOS)) {
              _this2.hasAccessToPage = false;
            }
            if (_this2.hasAccessToPage) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            if (!isAdminNotConsultant(_this2.loggedUserData)) {
              if (!isConsultantOrHolding(_this2.loggedUserData)) {
                _this2.userIdTarget = getIdUserFromSession();
              }
            }
            if (!_this2.tastingPhotoRequiredId) {
              _context.next = 7;
              break;
            }
            _context.next = 7;
            return _this2.prepareForTastingPhotoRequiredId();
          case 7:
            if (!_this2.userIdTarget) {
              _context.next = 12;
              break;
            }
            _context.next = 10;
            return _this2.getRequiredPhotosForUser();
          case 10:
            _context.next = 14;
            break;
          case 12:
            _context.next = 14;
            return _this2.getAvailableUsers();
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    prepareForTastingPhotoRequiredId: function prepareForTastingPhotoRequiredId() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.form.contents = [{
                tastingPhotoRequiredId: _this3.tastingPhotoRequiredId,
                nbBottles: 1
              }];
              if (!(isAdminNotConsultant(_this3.loggedUserData) || isConsultantOrHolding(_this3.loggedUserData))) {
                _context2.next = 9;
                break;
              }
              _this = _this3;
              _context2.next = 5;
              return request("/v1/tasting-photos/required/".concat(_this3.tastingPhotoRequiredId), "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get details of initial tasting photo required", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 5:
              response = _context2.sent;
              result = _objectSpread({}, response.data.value);
              _this3.userIdTarget = result.user.id;
              _this3.availableUsers.items = [{
                id: result.user.id,
                name: result.user.fullName
              }];
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getAvailableUsers: function getAvailableUsers() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$availableUsers$, _response$data$value$;
        var _this, urlApi, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.availableUsers.isPending = true;
              _this4.availableUsers.items = [];
              _this = _this4;
              (_this$availableUsers$ = _this.availableUsers.cancellationToken) === null || _this$availableUsers$ === void 0 || _this$availableUsers$.cancel();
              _this.availableUsers.cancellationToken = axios.CancelToken.source();
              urlApi = "/v1/tasting-photos/required/user-filters";
              if (isAdminNotConsultant(_this4.loggedUserData)) {
                urlApi = "/v1/tasting-photos/required/filters";
              }
              _context3.next = 9;
              return request(urlApi, "get", null, true, "api", null, _this.availableUsers.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.availableUsers.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load users available.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 9:
              response = _context3.sent;
              _this4.availableUsers.items = _toConsumableArray((_response$data$value$ = response.data.value.users) !== null && _response$data$value$ !== void 0 ? _response$data$value$ : []);
              _this4.availableUsers.isPending = false;
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getRequiredPhotosForUser: function getRequiredPhotosForUser() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$availablePhotos, _response$data$value$2, _response$data$value, _this, dataForSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this5.userIdTarget) {
                _context4.next = 13;
                break;
              }
              _this5.availablePhotosRequired.isPending = true;
              _this5.availablePhotosRequired.items = [];
              _this = _this5;
              (_this$availablePhotos = _this.availablePhotosRequired.cancellationToken) === null || _this$availablePhotos === void 0 || _this$availablePhotos.cancel();
              _this.availablePhotosRequired.cancellationToken = axios.CancelToken.source();
              dataForSearch = {
                userIds: [+_this5.userIdTarget],
                allowedStatus: [TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id, TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id]
              };
              paramsQuery = Object.encodeToUri(dataForSearch);
              _context4.next = 10;
              return request("/v1/tasting-photos/required?params=".concat(paramsQuery), "get", null, true, "api", null, _this.availablePhotosRequired.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.availablePhotosRequired.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load required photos");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 10:
              response = _context4.sent;
              _this5.availablePhotosRequired.items = _toConsumableArray((_response$data$value$2 = (_response$data$value = response.data.value) === null || _response$data$value === void 0 ? void 0 : _response$data$value.map(function (x) {
                x.name = "From ".concat(x.fromReference.shorterReference(), ", ").concat(x.nbBottlesRemaining, "b. of ").concat(x.wine.displayName);
                return x;
              })) !== null && _response$data$value$2 !== void 0 ? _response$data$value$2 : []);
              _this5.availablePhotosRequired.isPending = false;
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    changeUserTarget: function changeUserTarget() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.form = _objectSpread({}, defaultForm);
              _this6.getRequiredPhotosForUser();
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    addContent: function addContent() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.form.contents.push(_objectSpread({}, defaultForm.contents[0]));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    removeContent: function removeContent(index) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this8.form.contents.splice(index, 1);
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    syncFiles: function syncFiles(uploaderFiles) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.uploaderFiles = _toConsumableArray(uploaderFiles);
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    submitCreationForm: function submitCreationForm() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this10.isSaving = true;
              _this10.$refs.uploaderTastingPhoto.uploadAll(true);
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    acknowledgeUpload: function acknowledgeUpload(response) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.isSaving = false;
              _this11.close();
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    uploadFailed: function uploadFailed() {
      this.isSaving = false;
    },
    open: function open() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this12.resetData();
              _this12.dialog = true;
              if (!_this12.tastingPhotoRequiredId) {
                _context11.next = 5;
                break;
              }
              _context11.next = 5;
              return _this12.prepareForTastingPhotoRequiredId();
            case 5:
              return _context11.abrupt("return", new Promise(function (resolve, reject) {
                _this12.resolve = resolve;
                _this12.reject = reject;
              }));
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    close: function close() {
      this.dialog = false;
      this.resetData();
      this.$emit("closed");
    },
    resetData: function resetData() {
      if (isAdminNotConsultant(this.loggedUserData)) {
        this.userIdTarget = null;
      }
      this.form = _objectSpread({}, defaultForm);
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isConsultantOrHolding: isConsultantOrHolding
  }
};